<template>
  <div class="wrapper" ref="wrap">
    <div class="text "
    :class="{'full':unfold}"
    :data-state="unfold"
    :style="{'max-height':!unfold?row*(lineheight)+'rem':'none'}"
    >
    <!-- !unfold?row*(lineheight)+'rem':'auto' -->
    <label 
      v-if="moreBtn" 
      class="btn" 
      :class="{'ative_label':unfold}" 
      @click="checkboxChange">
      <span class="ico ico-down" v-if="!unfold"></span>
      <span class="ico ico-up" v-else></span>
    </label>
    <i ref="content" >{{ content }}</i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FoldTxt2',
  props: { content:String,
    row:{
      type:Number|String,
      default:2,
    },
    lineheight:{
      type:String | Number,
      default:20
    }
  },
  watch:{
    content:{
      handler(newv,oldv){
        if(newv){
          this.$nextTick(()=>{
            let height = this.$refs.content.offsetHeight
            if(height <= this.row * this.lineheight){
              this.moreBtn = false
            } 
          })
        }
      },immediate:true
    }
  },
  data(){
    return{
      moreBtn:true,
      unfold:false,
      oranginHeight:'',
      maxHeight:''
    }
  },
  methods:{
    checkboxChange(){
      this.unfold  = !this.unfold
      if(this.unfold && this.getWrapHeight() > 100*baseline ){
        this.$emit("update:max",'100rem')
      }else{
        this.$emit("update:max",'auto')
      }
    },

    getWrapHeight(){
      this.$nextTick(()=>{
        let height = this.$refs.wrap.offsetHeight
        
      })
      
    }
  },
}
</script>
<style  lang="scss">
   .wrapper {
    display: flex;
    overflow: hidden;
    // margin-bottom: 20rem;
  }
  
.text {
  font-size: 12rem;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  position: relative;
  line-height: 20rem;
  /* max-height: calc(39rpx*3); */
}

.text::before {
  content: '';
  // height: 100%;
  height: calc(100% - 20rem);
  float: right;
}
.full.text::before{
  height: calc(100% - 20rem);
  // float: none;
  // width: 100%;
}

.btn {
  position: relative;
  float: right;
  clear: both;
  // margin-left: 10rem;
  font-size: 12rem;
  // padding: 0 8rem;
  padding-left: 8rem;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  &.ative_label{
    padding-top: 1px;
  }
  .ico{
    width:20rem;
    height:20rem;
    position: relative;
    // top: 2rem;
    /* .ative_label &{
      top:0
    } */
  }
}

.btn::before{
  content:'展开';
}

.ative {
  max-height: none;
}


.ative_label::before{
  content: "收起";
}




</style>